const t = "Tili", a = "Tilin saldo", e = "Tilin kuvaus", n = "Tilin tunnus", i = "Lisäykset", s = "Korjaukset", o = "Summa", u = "ja", l = "Käytä", r = "Takaisin", c = "Saldotili", k = "Saldotilin tunnus", p = "Varattu", y = "Kirjattu", m = "Luokka", d = "Maksunpalautukset", h = "Sulje", v = "Ota yhteyttä asiakaspalveluun", f = "Pyydä apua ottamalla yhteyttä tukeen.", j = "Pyydä apua ottamalla yhteyttä tukeen. Kerro tuelle seuraava virhekoodi: %{requestId}.", T = "Kopioitu", g = "Kopioi", P = "Korjaukset", A = "Valuutta", R = "Päivämäärä", S = "Päivämääräalue", O = "Kuvaus", M = "Hylkää", F = "Lataa", C = "Ladataan", N = "Sähköposti", L = "Entiteettiä ei löytynyt", b = "Maksutapahtumaa ei löydy määritetylle tilinhaltijalle", x = "Palkkiot", w = "Tiedosto", D = "Suodatinpalkki", I = "Alku", V = "Täynnä", W = "Kirjatut varat", E = "Palaa takaisin", K = "Avustus myönnetty", B = "Avustusten takaisinmaksut", Y = "Piilota sisältö", q = "Henkilöllisyystodistus", H = "Puutteellinen kenttä", J = "Käynnissä", U = "Ladataan", _ = "enint.", G = "väh.", X = "Mobiili", z = "Nettomaksu", Q = "Seuraavat maksut", Z = "Ei tietoja", $ = "Negatiivisia lukuja ei sallita", tt = "Maksuja ei löytynyt", at = "Raportteja ei löytynyt", et = "Maksutapahtumia ei löytynyt", nt = "Muu", it = "Sivutettu siirtyminen", st = "Osittain", ot = "Maksutunnus", ut = "Maksutapa", lt = "Maksutiedot", rt = "Maksutiedot luodaan joka päivä keskiyöllä (UTC-aikaa).", ct = "Maksut", kt = "Odottaa", pt = "Tule takaisin myöhemmin.", yt = "Pyydä apua ottamalla yhteyttä tukeen.", mt = "Ota yhteyttä tukeen", dt = "Viitetunnus", ht = "Lataa uudelleen", vt = "Palautukset", ft = "Palautusmaksu", jt = "Emme voineet käsitellä hyvitystä. Yritä uudelleen myöhemmin.", Tt = "Jokin meni pieleen.", gt = "Asiakkaasi saa rahat viimeistään 40 päivän kuluessa. Kun palautus onnistuu, näet luettelossasi uuden maksutapahtuman.", Pt = "Palautus on lähetetty!", At = "Palautettava summa", Rt = "Hyvityksessä voi kestää jopa 40 päivää maksutavasta riippuen. Maksut sisältyvät hintaan.", St = "Palautus %{amount}", Ot = "Palautuksen syy", Mt = "Viite", Ft = "Jäljelle jäävä summa", Ct = "Raportti", Nt = "Raportit luodaan joka päivä keskiyöllä (UTC-aikaa).", Lt = "Raportit", bt = "Nollaa", xt = "Käänteinen", wt = "Jokin meni pieleen.", Dt = "Jotain on mennyt vikaan. Yritä ladata sivu uudelleen tai palata takaisin myöhemmin.", It = "Tila", Vt = "Jäsennetty luettelo", Wt = "Vähennykset", Et = "Samana päivänä suoritettujen maksujen summa", Kt = "Välilehdet", Bt = "Virhekoodi on %{requestId}", Yt = "Tuloksia ei ole", qt = "Pyynnöstä puuttuu pakollisia kenttiä tai se sisältää virheellisiä tietoja.", Ht = "Tapahtui odottamaton virhe", Jt = "Valittu saldotili on virheellinen", Ut = "Aikavyöhyke", _t = "Loppu", Gt = "Sisään yhteensä", Xt = "Ulos yhteensä", zt = "Loppuarvon tulee olla yhtä suuri tai suurempi kuin alkuarvo", Qt = "Maksutapahtuman tiedot", Zt = "Tapahtumat", $t = "Maksutapahtumien yleiskatsaus", ta = "Maksutapahtuman tyyppi", aa = "Siirrot", ea = "Kokeile toista hakua tai nollaa suodattimet, niin yritämme uudelleen.", na = "Yritä ladata sivu uudelleen tai palata takaisin myöhemmin.", ia = "Summa", sa = "Tyyppi", oa = "Arvo", ua = "Maksujen yleiskatsauksen lataaminen ei onnistunut.", la = "Raporttien yleiskatsauksen lataaminen ei onnistunut.", ra = "Maksutapahtumien yleiskatsauksen lataaminen ei onnistunut.", ca = "Saldotiliesi lataaminen ei onnistunut.", ka = "Maksujesi lataaminen ei onnistunut.", pa = "Raporttiesi lataaminen ei onnistunut.", ya = "Maksutapahtumiesi lataaminen ei onnistunut.", ma = {
  account: t,
  accountBalance: a,
  accountDescription: e,
  accountID: n,
  additions: i,
  adjustments: s,
  amount: o,
  and: u,
  apply: l,
  back: r,
  balanceAccount: c,
  balanceAccountId: k,
  Booked: p,
  "button.clearAll": "Tyhjennä kaikki",
  "calendar.controls": "Kalenterin siirtymistoiminnot",
  "calendar.nextMonth": "Ensi kuu",
  "calendar.previousMonth": "Edellinen kuukausi",
  "calendar.timezone": "Määritetty aikavyöhyke on GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Tilisi ei ole aktiivinen",
  "capital.actionNeeded": "Edellyttää toimia",
  "capital.bankAccountDetails": "Pankkitilin tiedot",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Tilinumero",
  "capital.bankCountryOrRegion": "Maa/alue",
  "capital.bankRoutingNumber": "Reititysnumero",
  "capital.bankSortCode": "Lajittelutunnus",
  "capital.businessFinancing": "Yritysrahoitus",
  "capital.businessFinancingOffer": "Yritysrahoitustarjous",
  "capital.businessFinancingSummary": "Yritysrahoituksen yhteenveto",
  "capital.closed": "Suljettu",
  "capital.couldNotContinueWithTheOffer": "Tarjouksen jatkaminen ei onnistunut.",
  "capital.couldNotLoadFinancialOffers": "Rahoitustarjousten lataaminen ei onnistunut",
  "capital.dailyRepaymentRate": "Päivittäinen takaisinmaksuprosentti",
  "capital.daysAndDaysLeft": "%{days} päivää (%{daysLeft} päivää jäljellä)",
  "capital.expectedRepaymentPeriod": "Odotettu takaisinmaksuaika",
  "capital.failed": "Epäonnistui",
  "capital.fees": "Palkkiot",
  "capital.fullyRepaid": "Maksettu täysin",
  "capital.goToTermsAndConditions": "Siirry ehtoihin",
  "capital.grantID": "Avustustunnus",
  "capital.howMuchMoneyDoYouNeed": "Kuinka paljon rahaa tarvitset?",
  "capital.inProgress": "Käynnissä",
  "capital.legalSubtitleAU": "Adyen Capitalin tarjoaa Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Lainat myöntää Adyen N.V.",
  "capital.legalSubtitleGB": "Lainat myöntää Adyen N.V., jota edustaa sen Lontoon haarakonttori.",
  "capital.legalSubtitleUS": "Lainat myöntää Adyen N.V:n San Franciscon sivukonttori. Lainat edellyttävät luottohyväksyntää.",
  "capital.maximumRepaymentPeriod": "Enimmäismaksuaika",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Vähimmäislyhennys %{days} päivän välein rahoituksen maksamiseksi ajoissa",
  "capital.needSomeExtraMoney": "Tarvitsetko lisärahaa?",
  "capital.offerLegalNoticeDescriptionUS": "Jos yritysluottohakemuksesi hylätään, sinulla on oikeus saada kirjallinen selvitys hylkäämisen syistä. Jos haluat saada selvityksen, ota yhteyttä Adyenin luottotukitiimiin lähettämällä sähköpostia osoitteeseen %{email} 60 päivän kuluessa siitä, kun olet saanut tiedon luottopäätöksestämme. Lähetämme sinulle kirjallisen selvityksen luottohakemuksen hylkäyssyistä 30 päivän kuluessa pyynnön vastaanottamisesta. %{break} Federal Equal Credit Opportunity Act ‑laki (Yhdysvaltain liittovaltion laki yhtäläisistä luottomahdollisuuksista) kieltää luotonantajia syrjimästä luotonhakijoita rodun, värin, uskonnon, kansallisen alkuperän, sukupuolen, siviilisäädyn tai iän perusteella (edellyttäen, että hakijalla on oikeuskelpoisuus tehdä sitova sopimus) tai sillä perusteella, että kaikki tai osa hakijan tuloista on peräisin julkisesta avustusohjelmasta, tai siitä syystä, että hakija on vilpittömässä mielessä käyttänyt jotakin kuluttajaluottosuojalain mukaista oikeutta. Liittovaltion virasto, joka hallinnoi tämän lain noudattamista tämän luotonantajan osalta, on Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Luotonantaja: Adyen N.V. – San Franciscon sivukonttori %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 kuukausi",
  "capital.pending": "Odottaa",
  "capital.primaryAccount": "Ensisijainen tili",
  "capital.remaining": "Jäljellä",
  "capital.remainingAmount": "Jäljelle jäävä summa",
  "capital.remainingFees": "Jäljellä olevat maksut",
  "capital.repaid": "Maksettu takaisin",
  "capital.repaidAmount": "Takaisin maksettu summa",
  "capital.repaidFees": "Maksetut palkkiot",
  "capital.repaymentBalanceInfo": "Nykyinen jäljellä oleva summa, mukaan lukien maksut, on %{amount}",
  "capital.repaymentThreshold": "Lyhennyksen raja-arvo",
  "capital.requestedFunds": "Pyydetyt varat",
  "capital.requestFunds": "Pyydä varoja",
  "capital.requesting": "Pyydetään",
  "capital.reviewOffer": "Tarkista tarjous",
  "capital.revoked": "Kumotettu",
  "capital.seeNewOffer": "Näytä uusi tarjous",
  "capital.seeOptions": "Näytä vaihtoehdot",
  "capital.sendRepayment": "Lähetä takaisinmaksu",
  "capital.sendRepaymentNotice": "Lainan ylimääräisen lyhennyksen käsittelyssä ja sen näkymisessä lainatililläsi voi kestää 2–3 arkipäivää.",
  "capital.sendRepaymentSubtitle": "Jos haluat lyhentää lainaa tai maksaa sen pois kokonaan, siirrä rahaa tälle pankkitilille.",
  "capital.signTermsAndConditionsToReceiveFunds": "Saat varat, kun allekirjoitat ehdot.",
  "capital.signTheTermsToReceiveYourFunds": "Saat varat, kun allekirjoitat ehdot",
  "capital.termEnds": "Kausi päättyy: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Ensisijaista tiliä ei ole määritetty",
  "capital.thisOfferExpiresOn": "Tämä tarjous päättyy %{date}.",
  "capital.totalFees": "Palkkiot yhteensä",
  "capital.totalRepaymentAmount": "Takaisin maksettava kokonaissumma",
  "capital.unsupportedRegionDescription": "Yritysrahoitusta ei ole vielä saatavilla alueellasi, mutta tarkista tilanne täältä myöhemmin uudelleen ja pyydä tarjous, jos rahoitusta on myöhemmin tarjolla.",
  "capital.unsupportedRegionTitle": "Pysy kuulolla!",
  "capital.weCouldNotContinueWithTheOffer": "Tarjouksen jatkaminen ei onnistunut.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Tarjouksen jatkaminen ei onnistunut. Pyydä apua ottamalla yhteyttä tukeen.",
  "capital.weCouldNotLoadFinancialOffers": "Rahoitustarjousten lataaminen ei onnistunut",
  "capital.weCouldNotProcessThisRequestTryAgain": "Emme voineet käsitellä tätä pyyntöä. Yritä uudelleen uudella tarjouksella.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Saimme pyyntösi ja käsittelemme sitä parhaillaan. Saat ohjeet jatkotoimiin pian.",
  "capital.writtenOff": "Poistettu",
  "capital.xDays": "%{days} päivää",
  "capital.xMonths": "%{months} kuukautta",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Hyväksyit nämä varat, mutta palautit ne",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Hyväksyit nämä varat, mutta et maksanut niitä takaisin.",
  "capital.youAreRequestingFundingOf": "Pyydät rahoitusta:",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Olet esikelpuutettu yritysrahoitukseen",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " jopa %{amount} saakka",
  "capital.yourRequestedFundsWere": "Pyytämäsi varat: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Sinun pitäisi saada varat yhden työpäivän kuluessa",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Sinun on maksettava takaisin vähintään %{amount} joka %{days} päivä, jotta voit maksaa varat kokonaan pois %{date} mennessä.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Olet pian oikeutettu rahoitustarjoukseen!",
  capture: y,
  category: m,
  chargeback: d,
  closeIconLabel: h,
  contactSupport: v,
  contactSupportForHelp: f,
  contactSupportForHelpAndShareErrorCode: j,
  copied: T,
  copy: g,
  correction: P,
  currency: A,
  date: R,
  dateRange: S,
  default: "Oletus",
  description: O,
  dismiss: M,
  download: F,
  downloading: C,
  email: N,
  entityWasNotFound: L,
  entityWasNotFoundDetail: b,
  "error.pleaseTryAgainLater": "Yritä myöhemmin uudelleen.",
  "error.somethingWentWrongWithDownload": "Latauksessa meni jokin pieleen",
  "expandableCard.collapse": "Pienennä",
  "expandableCard.expand": "Suurenna",
  export: "Vie",
  fee: x,
  file: w,
  "filter.date.since": "%{date} alkaen",
  "filter.date.until": "%{date} saakka",
  filterBar: D,
  "filterPlaceholder.category": "Tyyppi",
  "filterPlaceholder.currency": "Valuutta",
  "filterPlaceholder.status": "Tila",
  from: I,
  full: V,
  fundsCaptured: W,
  goBack: E,
  grantIssued: K,
  grantRepayment: B,
  hideContent: Y,
  id: q,
  incompleteField: H,
  inProgress: J,
  loading: U,
  max: _,
  min: G,
  mobile: X,
  netPayout: z,
  nextPayouts: Q,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: tt,
  noReportsFound: at,
  noTransactionsFound: et,
  other: nt,
  paginatedNavigation: it,
  "pagination.nextPage": "Seuraava sivu",
  "pagination.previousPage": "Edellinen sivu",
  "pagination.showing": "Näytetään",
  partial: st,
  paymentId: ot,
  paymentMethod: ut,
  payoutDetails: lt,
  payoutsNotice: rt,
  payoutsTitle: ct,
  Pending: kt,
  pleaseComeBackLater: pt,
  pleaseReachOutToSupportForAssistance: yt,
  "rangePreset.custom": "Mukautettu",
  "rangePreset.last30Days": "Viimeiset 30 päivää",
  "rangePreset.last7Days": "Viimeiset 7 päivää",
  "rangePreset.lastMonth": "Viime kuu",
  "rangePreset.lastWeek": "Viime viikko",
  "rangePreset.thisMonth": "Tämä kuukausi",
  "rangePreset.thisWeek": "Tämä viikko",
  "rangePreset.yearToDate": "Vuoden alusta",
  reachOutToSupport: mt,
  referenceID: dt,
  refresh: ht,
  refund: vt,
  "refund.amountAlreadyRefunded": "Olet jo hyvittänyt %{amount}",
  "refund.amountFailed": "Summan (%{amount}) hyvitys epäonnistui. Tätä summaa ei ole tällä hetkellä mahdollista hyvittää. Ota yhteyttä tukeen.",
  "refund.amountInProgress": "Summan (%{amount}) osittaista hyvitystä käsitellään.",
  "refund.fee": "Palkkio",
  "refund.fullAmountFailed": "Tätä maksua ei ole mahdollista palauttaa. Ota yhteyttä tukeen",
  "refund.fullAmountRefunded": "Koko summa on palautettu asiakkaalle",
  "refund.goToPayment": "Siirry maksuun",
  "refund.maximumRefundable": "Voit hyvittää enintään %{amount}",
  "refund.onlyRefundable": "Voit hyvittää vain %{amount}",
  "refund.originalAmount": "Alkuperäinen summa",
  "refund.originalPayment": "Alkuperäinen maksu",
  "refund.paymentPspReference": "Maksun PSP-viite",
  "refund.pspReference": "PSP-viite",
  "refund.refundFee": "Palautusmaksu",
  "refund.refundPspReference": "Hyvitä PSP-viite",
  "refund.returnToRefund": "Palauta hyvitykseen",
  "refund.theRefundIsBeingProcessed": "Palautusta käsitellään parhaillaan.",
  refundAction: ft,
  refundActionErrorSubtitle: jt,
  refundActionErrorTitle: Tt,
  refundActionSuccessSubtitle: gt,
  refundActionSuccessTitle: Pt,
  refundAmount: At,
  "refundAmount.excess": "Summa voi olla enintään %{amount}",
  "refundAmount.required": "Syötä hyvityssumma",
  "refunded.full": "Täysin hyvitetty",
  "refunded.partial": "Osittain hyvitetty",
  refundNotice: Rt,
  refundPayment: St,
  refundReason: Ot,
  "refundReason.duplicate": "Kopio",
  "refundReason.fraudulent": "Vilpillinen",
  "refundReason.issue_with_item_sold": "Ongelma myydyn kohteen kanssa",
  "refundReason.other": "Muu",
  "refundReason.requested_by_customer": "Asiakkaan pyytämä",
  refundReference: Mt,
  "refundReference.placeholder": "Syötä viite tähän",
  remainingAmount: Ft,
  report: Ct,
  "reportsError.tooManyDownloads": "Kaikkien tiedostojen lataaminen ei onnistunut. Yritä myöhemmin uudelleen.",
  reportsNotice: Nt,
  reportsTitle: Lt,
  "reportType.payout": "Maksu",
  reset: bt,
  Reversed: xt,
  "select.filter.placeholder": "Paikkamerkki",
  "select.noOptionsFound": "Mikään vaihtoehto ei vastaa tätä hakua",
  somethingWentWrong: wt,
  somethingWentWrongTryRefreshingOrComeBackLater: Dt,
  status: It,
  structuredList: Vt,
  subtractions: Wt,
  sumOfSameDayPayouts: Et,
  tabs: Kt,
  theErrorCodeIs: Bt,
  thereAreNoResults: Yt,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: qt,
  thereWasAnUnexpectedError: Ht,
  theSelectedBalanceAccountIsIncorrect: Jt,
  timezone: Ut,
  to: _t,
  "tooltip.ATM": "Pankkiautomaatista nostetut rahat",
  "tooltip.Capital": "Rahat saapuvasta laina-avustuksesta tai lähtevästä lainan takaisinmaksusta",
  "tooltip.Chargeback": "Asiakkaalle kiistanalaisen maksutapahtuman jälkeen palautetut rahat",
  "tooltip.Correction": "Varojesi korjaukset, mukaan lukien maksutapahtumien peruutukset ja talletusten korjaukset",
  "tooltip.Fee": "Maksutapakulut ja maksutapapalkkiot",
  "tooltip.Other": "Maksutapahtumat, jotka eivät kuulu muuhun mihinkään muuhun luokkaan, yleensä nämä ovat korjauksia",
  "tooltip.Payment": "Myyntitapahtumasta tilillesi tulleet rahat",
  "tooltip.Refund": "Asiakkaalle hyvitetystä maksutapahtumasta palautetut rahat",
  "tooltip.totalIncoming": "Kaikki tilillesi tulleet rahat valittujen suodattimien perusteella",
  "tooltip.totalOutgoing": "Kaikki palkkiot, hyvitykset, maksut ja muut veloitukset valittujen suodattimien perusteella",
  "tooltip.Transfer": "Rahaa siirrettiin tilisi ja toisen tilin välillä",
  totalIncoming: Gt,
  totalOutgoing: Xt,
  toValueShouldBeGreaterThanTheFromValue: zt,
  transactionDetails: Qt,
  transactions: Zt,
  transactionsOverviewTitle: $t,
  transactionType: ta,
  transfer: aa,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: ea,
  tryRefreshingThePageOrComeBackLater: na,
  txAmount: ia,
  "txType.ATM": "Pankkiautomaatti",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Maksun palautus",
  "txType.Correction": "Korjaus",
  "txType.Fee": "Palkkio",
  "txType.Other": "Muu",
  "txType.Payment": "Maksu",
  "txType.Refund": "Palautus",
  "txType.Transfer": "Siirto",
  type: sa,
  value: oa,
  weCouldNotLoadThePayoutsOverview: ua,
  weCouldNotLoadTheReportsOverview: la,
  weCouldNotLoadTheTransactionsOverview: ra,
  weCouldNotLoadYourBalanceAccounts: ca,
  weCouldNotLoadYourPayouts: ka,
  weCouldNotLoadYourReports: pa,
  weCouldNotLoadYourTransactions: ya
};
export {
  p as Booked,
  kt as Pending,
  xt as Reversed,
  t as account,
  a as accountBalance,
  e as accountDescription,
  n as accountID,
  i as additions,
  s as adjustments,
  o as amount,
  u as and,
  l as apply,
  r as back,
  c as balanceAccount,
  k as balanceAccountId,
  y as capture,
  m as category,
  d as chargeback,
  h as closeIconLabel,
  v as contactSupport,
  f as contactSupportForHelp,
  j as contactSupportForHelpAndShareErrorCode,
  T as copied,
  g as copy,
  P as correction,
  A as currency,
  R as date,
  S as dateRange,
  ma as default,
  O as description,
  M as dismiss,
  F as download,
  C as downloading,
  N as email,
  L as entityWasNotFound,
  b as entityWasNotFoundDetail,
  x as fee,
  w as file,
  D as filterBar,
  I as from,
  V as full,
  W as fundsCaptured,
  E as goBack,
  K as grantIssued,
  B as grantRepayment,
  Y as hideContent,
  q as id,
  J as inProgress,
  H as incompleteField,
  U as loading,
  _ as max,
  G as min,
  X as mobile,
  z as netPayout,
  Q as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  tt as noPayoutsFound,
  at as noReportsFound,
  et as noTransactionsFound,
  nt as other,
  it as paginatedNavigation,
  st as partial,
  ot as paymentId,
  ut as paymentMethod,
  lt as payoutDetails,
  rt as payoutsNotice,
  ct as payoutsTitle,
  pt as pleaseComeBackLater,
  yt as pleaseReachOutToSupportForAssistance,
  mt as reachOutToSupport,
  dt as referenceID,
  ht as refresh,
  vt as refund,
  ft as refundAction,
  jt as refundActionErrorSubtitle,
  Tt as refundActionErrorTitle,
  gt as refundActionSuccessSubtitle,
  Pt as refundActionSuccessTitle,
  At as refundAmount,
  Rt as refundNotice,
  St as refundPayment,
  Ot as refundReason,
  Mt as refundReference,
  Ft as remainingAmount,
  Ct as report,
  Nt as reportsNotice,
  Lt as reportsTitle,
  bt as reset,
  wt as somethingWentWrong,
  Dt as somethingWentWrongTryRefreshingOrComeBackLater,
  It as status,
  Vt as structuredList,
  Wt as subtractions,
  Et as sumOfSameDayPayouts,
  Kt as tabs,
  Bt as theErrorCodeIs,
  qt as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  Jt as theSelectedBalanceAccountIsIncorrect,
  Yt as thereAreNoResults,
  Ht as thereWasAnUnexpectedError,
  Ut as timezone,
  _t as to,
  zt as toValueShouldBeGreaterThanTheFromValue,
  Gt as totalIncoming,
  Xt as totalOutgoing,
  Qt as transactionDetails,
  ta as transactionType,
  Zt as transactions,
  $t as transactionsOverviewTitle,
  aa as transfer,
  ea as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  na as tryRefreshingThePageOrComeBackLater,
  ia as txAmount,
  sa as type,
  oa as value,
  ua as weCouldNotLoadThePayoutsOverview,
  la as weCouldNotLoadTheReportsOverview,
  ra as weCouldNotLoadTheTransactionsOverview,
  ca as weCouldNotLoadYourBalanceAccounts,
  ka as weCouldNotLoadYourPayouts,
  pa as weCouldNotLoadYourReports,
  ya as weCouldNotLoadYourTransactions
};
